<div class="container">
    <h2 *ngIf="data.type==='company'">Delete {{ data.name }} Company</h2>
    <h2 *ngIf="data.type==='user'">Delete {{ data.name }} User</h2>
    <h2 *ngIf="data.type==='gateway'">Delete {{ data.name }} Gateway</h2>
    <h2 *ngIf="data.type==='cycle'">Delete {{ data.name }} Cycle</h2>
    <h2 *ngIf="data.type==='end'">End {{ data.name }} Cycle</h2>
    <p *ngIf="data.type!=='end'">Are you sure you want to delete the {{ data.name }} {{data.type}} ? </p>
    <p *ngIf="data.type==='end'">Are you sure you want to end the {{ data.name }} {{data.type}} ? </p>
    <!-- <mat-form-field>
        <p>Are you sure you want to delete the {{ data.name }} {{data.type}} ? </p>
        <mat-checkbox [(ngModel)]="data.name">Delete {{data.name}} company </mat-checkbox>
        <mat-checkbox [(ngModel)]="data.deleteRelatedGateways">Delete related gateways </mat-checkbox>
        <mat-checkbox [(ngModel)]="data.deleteRelatedZones">Delete related zones </mat-checkbox>
        <mat-checkbox [(ngModel)]="data.deleteRelatedSensors">Delete related sensors </mat-checkbox>
    </mat-form-field> -->
    <mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]="undefined">Cancel</button>
        <button  *ngIf="data.type!=='end'" mat-flat-button color="primary" (click)="onConfirm()">Delete {{data.type}}</button>
        <button *ngIf="data.type==='end'" mat-flat-button color="primary" (click)="onConfirm()">End cycle</button>
    </mat-dialog-actions>
    <div class="loading-wrapper" *ngIf="isLoading">
        <mat-spinner diameter="30"></mat-spinner>
    </div>
</div>